import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.send('service_x40bhxy', 'template_test',       {
            to_name: 'Romain KORDALSKI',
            from_name: formData.firstName + ' ' + formData.lastName,
            from_email: formData.email,
            message: formData.message,
          }, 'vVHzb1696CJ8dX91T')
            .then((response) => {
                console.log('Message sent successfully!', response.status, response.text);
                toast.success('Message envoyé avec succès!');
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    message: ''
                });
            }, (error) => {
                console.error('Failed to send message.', error);
                toast.error('Échec de l\'envoi du message. Veuillez réessayer.');
            });
    };

    return (
        <div className="contact-form">
            <h2>Contact</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Nom:
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
                </label>
                <label>
                    Prénom:
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
                </label>
                <label>
                    Email:
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                </label>
                <label>
                    Message:
                    <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>
                </label>
                <button type="submit">Envoyer message</button>
            </form>
            <ToastContainer />
        </div>
    );
};

export default ContactForm;

